/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 08:58:58
 * @LastEditTime: 2022-03-08 15:27:32
 */
import i18n from "@/common/lang";
const statusSelect = [
  { label: i18n.t('lang.devicelist.connected'), value: 1 },
  { label: i18n.t('lang.devicelist.not'), value: 2 },
]
export const Columns = [
  { LabelName: i18n.t('lang.FastAccess.deviceSn'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true },
  { LabelName: i18n.t('lang.devicelist.Serial'), key: 1, ColumnsKey: 'deviceSn', seek: 'deviceSn', sort: 'custom', placeholder: i18n.t('lang.FastAccess.deviceSn') },
  { LabelName: i18n.t('lang.devicelist.Name'), key: 2, ColumnsKey: 'deviceName', seek: 'deviceName', placeholder: i18n.t('lang.alarmList.devicename'), sort: 'custom' },
  // { LabelName: i18n.t('lang.devicelist.FirstLevelProject'), key: 3, ColumnsKey: 'firstLevelName' }, 
  // { LabelName: i18n.t('lang.devicelist.SecondLevelProject'), key: 4, ColumnsKey: 'secondLevelName'},   
  { LabelName: i18n.t('lang.devicelist.statevoid'), select: true, selectOptions: statusSelect, seek: 'deviceState', align: 'center', key: 5, ColumnsKey: 'deviceIsconnected', Tag: true, Fun: 'GetStatus' },
  { LabelName: i18n.t('lang.devicelist.IP'), key: 6, ColumnsKey: 'deviceIp', seek: 'deviceIp', sort: 'custom' },
  { LabelName: i18n.t('lang.devicelist.DeviceAddress'), key: 7, ColumnsKey: 'deviceAddress', seek: 'deviceAddress', sort: 'custom' },
]

export const ColuumnsButton = [
  // { key: 0, type: 'primary', icon: 'el-icon-setting', Fun: 'showVariable', Authority: 53, tipValue: '查看变量' },
  { key: 1, type: 'primary', icon: 'icon-chaxun', Fun: 'showDetail', Authority: 53, tipValue: i18n.t('lang.varlist.viewterminal') },
  { key: 2, type: 'danger', icon: 'el-icon-delete', Fun: 'deleteDevice', Delete: true, Authority: 235, tipValue: i18n.t('lang.Button.delete') },
]
